import $axios from '@/api/apiPublic';

const getContacts = async () => {
  const response = await $axios.get('contacts');
  return response;
};

export default {
  getContacts,
};
